import React from "react";
import { GlobalMessage } from "../components/GlobaleMessage";

export const MainLayout = ({ children }) => {
  return (
    <div>
      <GlobalMessage />

      {children}
    </div>
  );
};